// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1u7ZM","detailsBorder":"styles_detailsBorder__37Iox"};